// Generated from SVG to Code Figma Plugin

import type { JSX } from 'react';

export const Feat2 = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M43.999 68L51.999 76C52.787 76.7879 53.7224 77.413 54.7518 77.8394C55.7813 78.2658 56.8847 78.4853 57.999 78.4853C59.1133 78.4853 60.2167 78.2658 61.2462 77.8394C62.2757 77.413 63.2111 76.7879 63.999 76C64.787 75.2121 65.412 74.2767 65.8384 73.2472C66.2648 72.2177 66.4843 71.1143 66.4843 70C66.4843 68.8857 66.2648 67.7823 65.8384 66.7528C65.412 65.7233 64.787 64.7879 63.999 64"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="8"
    />
    <path
      d="M56.0009 56.0001L66.0009 66.0001C67.5922 67.5914 69.7505 68.4853 72.0009 68.4853C74.2513 68.4853 76.4096 67.5914 78.0009 66.0001C79.5922 64.4088 80.4862 62.2505 80.4862 60.0001C80.4862 57.7496 79.5922 55.5914 78.0009 54.0001L62.4809 38.4801C60.2309 36.2329 57.1809 34.9706 54.0009 34.9706C50.8209 34.9706 47.7709 36.2329 45.5209 38.4801L42.0009 42.0001C40.4096 43.5914 38.2513 44.4853 36.0009 44.4853C33.7505 44.4853 31.5922 43.5914 30.0009 42.0001C28.4096 40.4088 27.5156 38.2505 27.5156 36.0001C27.5156 33.7496 28.4096 31.5914 30.0009 30.0001L41.2409 18.7601C44.8899 15.1206 49.6485 12.8023 54.7635 12.172C59.8785 11.5416 65.0576 12.6354 69.4809 15.2801L71.3609 16.4001C73.0641 17.428 75.0891 17.7845 77.0409 17.4001L84.0009 16.0001"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="8"
    />
    <path
      d="M83.999 12L87.999 56H79.999"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="8"
    />
    <path
      d="M11.999 12L7.99902 56L33.999 82C35.5903 83.5913 37.7486 84.4853 39.999 84.4853C42.2495 84.4853 44.4077 83.5913 45.999 82C47.5903 80.4087 48.4843 78.2504 48.4843 76C48.4843 73.7496 47.5903 71.5913 45.999 70"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="8"
    />
    <path d="M12 16H44" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8" />
  </svg>
);
